import React from 'react';
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import ClinicList from '../../containers/clinics/ClinicList';
import ClinicsProvider from '../../store/clinics/clinicsProvider';

function ClinicManagerPage() {  

  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';

  return (
    <ClinicsProvider>
      <PageWrapper navbar title='Clinic Manager'>
          <ClinicList />
      </PageWrapper>
    </ClinicsProvider>
  )
}

export default ClinicManagerPage;
